module.exports = __webpack_public_path__ + "static/media/2.f5007fd0.png";